import type { ReactNode } from 'react';
import { Icon } from './Icon';
import './EmptyState.scss';

interface EmptyStateProps {
  /** Material icon shown above the text. */
  icon?: string;
  /** One line saying what is missing ("No trial balances yet"). */
  title: string;
  /** Optional second line saying what to do about it. */
  hint?: string;
  /** The screen's own primary action (the button it already has), when it has one. */
  action?: ReactNode;
}

/**
 * What a list shows when it has no rows (design review 2 Nov: the blank white page under an empty list "is not looking good"). One look for
 * every list: an icon, one line, an optional hint and the screen's primary action. Pass it as a DataTable `noDataMessage` once the list has
 * loaded, never while it is still loading.
 */
export function EmptyState({ icon = 'inbox', title, hint, action }: EmptyStateProps) {
  return (
    <div className="empty-state" role="status">
      <Icon name={icon} outlined className="empty-state-icon" />
      <p className="empty-state-title">{title}</p>
      {hint && <p className="empty-state-hint">{hint}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
